import { ConfigProps } from '@config/types'

const config = ({
  deploymentEnv,
  chaptersApiUrl,
  baseUrl,
  videoMetadataUrl,
}: ConfigProps) => ({
  durationFormat: 'm:ss',
  policyKey:
    'BCpkADawqM1CmLU_NRRct02h_NHz1WnONNeRnXKu0AcNFaXDfk8i2yYzb2p9_Z_LsYA-HpFEJzUwxtt8l8QDHLD_K0wpdAjvwRNgu46i5PPs4zj1vPVC6Wy4FBbfh9zm7JuYWd_mf2-uIyGB',
  accountId: '4772533039001',
  accountId___romandie: '6230718686001',
  shortVideoLengthThresholdInSeconds: 45,
  playerId: deploymentEnv === 'prod' ? 'n1X2gMGxU' : 'KZARTWkEb',
  playerId___romandie: deploymentEnv === 'prod' ? 'n1QCFlLIu' : 'GPMxC3CdN',
  chaptersApiUrl: `${chaptersApiUrl}/tv/metadata`,
  logoUrlBlickTV: `${baseUrl}/blick-tv-logo.png`,
  teaserBackgroundUrl: `${baseUrl}/blick-tv-teaser-background.png`,
  teaserBackgroundUrlWebp: `${baseUrl}/blick-tv-teaser-background.webp`,
  videoMetadataUrl: `${videoMetadataUrl}/metadata`,
  storageKeyCloseFloatingPlayerTimestamp: 'video:closeFloatingPlayerTimestamp',
  hideFloatingPlayerDurationInSeconds: 86400,
  storageKeyVideoPlayerSettings: 'video:playerSettings',
  story: {
    dvrWindow: 45,
    pollingIntervalInMilliseconds: 120000,
    showGoToLiveDelayInMilliseconds: 5000,
  },
})

export type configType = ReturnType<typeof config>
export default config
